import React from 'react';
import LogoFooter from '../assests/logoFooter.svg';
import { FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Container } from 'components/shared';

const Footer = ({ children, content, ...rest }) => {
  return (
    <div className="w-full  sm:py-20 p-4 bg-stone-800 flex-col justify-end items-start gap-12 inline-flex">
      <Container>
        <div className="w-full flex justify-between items-start flex-col lg:flex-row">
          <div className="flex-col justify-start items-start gap-8 inline-flex mb-9">
            <img
              src={LogoFooter}
              alt="Logotipo do App"
              className="w-[190px] object-cover"
            />
            <h4 className="text-stone-50">Cuide de Você, Comece pela Sua Pele.</h4>
            <div className="justify-start items-start gap-4 inline-flex">
              <Link to="/">
                <FaInstagram size={25} color={'white'} />
              </Link>
              <Link to="/">
                <FaTiktok size={25} color={'white'} />
              </Link>
              <Link to="/">
                <FaYoutube size={25} color={'white'} />
              </Link>
              <Link to="/">
                <FaLinkedin size={25} color={'white'} />
              </Link>
            </div>
          </div>

          <div className="justify-end items-start gap-20 flex flex-col lg:flex-row">
            <div className="flex-col justify-start items-start gap-[18px] inline-flex">
              <h3 className="text-stone-50 font-bold">Dermatologia</h3>
              <div className="flex-col justify-start items-start gap-4 flex">
                <Link className="text-stone-400" to="/">
                  Clínica
                </Link>
                <Link className="text-stone-400" to="/">
                  Estética
                </Link>
                <Link className="text-stone-400" to="/">
                  Pediátrica
                </Link>
                {/* <Link className="text-stone-400" to="/">
                  Oncológica
                </Link>
                <Link className="text-stone-400" to="/">
                  Cirúrgica
                </Link>
                <Link className="text-stone-400" to="/">
                  Tricologia
                </Link> */}
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-[18px] inline-flex">
              <h3 className="text-stone-50 font-bold">Empresa</h3>
              <div className="flex-col justify-start items-start gap-4 flex">
                <Link className="text-stone-400" to="/quem-somos">
                  Quem Somos
                </Link>
                {/* <Link className="text-stone-400" to="/">
                  Blog
                </Link> */}
                {/* <Link className="text-stone-400" to="/">
                  Materiais Ricos
                </Link> */}
                {/* <Link className="text-stone-400" to="/">
                  Trabalhe Conosco
                </Link> */}
                <Link className="text-stone-400" to="/contato">
                  Contato
                </Link>
                {/* <Link className="text-stone-400" to="/">
                  Seja um Parceiro
                </Link> */}
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-[18px] inline-flex">
              <h3 className="text-stone-50 font-bold">Ajuda</h3>
              <div className="flex-col justify-start items-start gap-4 flex">
                {/* <Link className="text-stone-400" to="/">
                  FAQ
                </Link> */}
                <Link className="text-stone-400" to="/politicas-de-privacidade">
                  Termos de uso
                </Link>
                <Link className="text-stone-400" to="/politicas-de-privacidade">
                  Termos de telemedicina
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="self-stretch h-[0px] border border-stone-600 my-9"></div>

        <div className="justify-between items-start gap-8 flex flex-col sm:flex-row">
          <Link className="text-stone-400" to="/politicas-de-privacidade">
            Política de privacidade
          </Link>

          <Link className="text-stone-400" to="https://castleit.io/" target="_blank">
            <span>by:</span>{' '}
            Castle
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
